import { Switch, TextField, Typography } from '@mui/material';
import { AddExternalUserGroupForm } from 'components/Drawer/types';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { lowerCase, upperFirst } from 'lodash';
import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import styled from 'styled-components';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

const StyledTextFieldNumber = styled(TextField)`
  /* Chrome, Safari, Edge, Opera */
  & input::-webkit-outer-spin-button,
  & input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  & input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export interface Props {
  register: UseFormRegister<AddExternalUserGroupForm>;
  nameInputValue: string;
  handleNameInputOnChange: (value: string) => void;
  nameInputValidation: string | undefined;
  showValidation: boolean;
  switchIsMaximumUserLimitEnable: boolean;
  handleSwitchIsMaximumUserLimitEnableOnChange: () => void;
  inputsMaximumUserLimitValue: number | null;
  inputsMaximumUserLimitValueValidation: string | undefined;
  handlesMaximumUserLimitInputOnChange: (value: number) => void;
  inputOnKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
}
const AddExternalUserGroup: React.FC<React.PropsWithChildren<Props>> = ({
  register,
  nameInputValue,
  handleNameInputOnChange,
  nameInputValidation,
  showValidation,
  switchIsMaximumUserLimitEnable,
  handleSwitchIsMaximumUserLimitEnableOnChange,
  inputsMaximumUserLimitValue,
  inputsMaximumUserLimitValueValidation,
  handlesMaximumUserLimitInputOnChange
}) => {
  const { translation } = useTranslation();

  return (
    <ComponentWrapper flexDirection="column" gap="1.5rem" margin="0.5rem 0 0 0">
      <TextField
        {...register('name')}
        onChange={(event) => handleNameInputOnChange(event.target.value)}
        label={`${translation.name}`}
        value={nameInputValue}
        id="drawer-input-name"
        variant="outlined"
        InputLabelProps={{ shrink: nameInputValue.length > 0 }}
        size="medium"
        error={showValidation && nameInputValidation !== undefined}
        helperText={showValidation ? nameInputValidation : undefined}
      />
      <ComponentWrapper gap="1rem" flexDirection="column">
        <ComponentWrapper flexDirection="row" gap="1rem" alignItems="center" width="100%" margin="0 0 0 0.5rem">
          <Switch
            {...register('isMaximumUserLimit')}
            color="primary"
            id="drawer-input-switch-user-limit"
            checked={switchIsMaximumUserLimitEnable}
            onClick={handleSwitchIsMaximumUserLimitEnableOnChange}
          />
          <Typography variant="body1">{translation.enable_maximum_user_limit}</Typography>
        </ComponentWrapper>
        <StyledTextFieldNumber
          {...register('maxNumberOfMembers')}
          label={upperFirst(lowerCase(translation.maximum_users))}
          type="number"
          variant="outlined"
          InputLabelProps={{ shrink: !!inputsMaximumUserLimitValue || inputsMaximumUserLimitValue === 0 }}
          size="medium"
          inputProps={{
            min: 0,
            max: 999
          }}
          value={inputsMaximumUserLimitValue}
          disabled={!switchIsMaximumUserLimitEnable}
          id="drawer-input-user-limit"
          onChange={
            switchIsMaximumUserLimitEnable
              ? (event) => handlesMaximumUserLimitInputOnChange(Number(event.target.value))
              : undefined
          }
          error={showValidation && inputsMaximumUserLimitValueValidation !== undefined}
          helperText={
            showValidation && inputsMaximumUserLimitValueValidation ? inputsMaximumUserLimitValueValidation : ''
          }
        />
      </ComponentWrapper>
    </ComponentWrapper>
  );
};

export default AddExternalUserGroup;
